// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20I6o","tabsBox":"styles_tabsBox__3gXR5","createButton":"styles_createButton__1kDFh"};